document.addEventListener("DOMContentLoaded", () => {
    const open = document.querySelector('.open-menu-item')
    const close = document.querySelector('.close-icon')
    const promoBanner = document.querySelector('.promo-banner')
    const openMenu = document.querySelector('.mobile-menu')
    const linkWithChild = document.querySelectorAll('.desktopMenu__itemWithChild--js');

    const menuTrigger = open ? open.querySelector('button[aria-expanded]') : null;

    if (open && openMenu) {
        openMenu.style.setProperty('--top-y', 0 + "px");
        open.addEventListener('click', () => {
            window.navigationV2Experiment = true;
            let myEvent = new CustomEvent('open:menu', {
                detail: {
                    message: 'mobile menu opened'
                }
            });
            // Dispatch the event
            document.dispatchEvent(myEvent);
            openMenu.classList.remove('mobile-menu__toggle')
            document.body.classList.add('oddit-overflow-y')
            if (menuTrigger) menuTrigger.setAttribute('aria-expanded', 'true');
            if (promoBanner) {
                if (promoBanner.offsetHeight > 0) {
                    openMenu.style.setProperty('--top-y', -(promoBanner.offsetHeight) + "px");
                } else {
                    openMenu.style.setProperty('--top-y', 0 + "px");
                }
            } else {
                openMenu.style.setProperty('--top-y', 0 + "px");
            }
        })
    }

    if (close && openMenu) {
        close.addEventListener('click', () => {
            openMenu.classList.add('mobile-menu__toggle')
            document.body.classList.remove('oddit-overflow-y')
            if (menuTrigger) menuTrigger.setAttribute('aria-expanded', 'false');
        })
    }

    function closeLink(target) {
        target.classList.remove('desktopMenu__itemWithChild--active');

        const childMenu = target.querySelector('.childMenu');
        if (childMenu) {
            childMenu.setAttribute('hidden', '');
            childMenu.setAttribute('inert', '');
            childMenu.setAttribute('aria-hidden', 'true');
        }

        const button = target.querySelector('.desktopMenu__itemWithChildTitle');
        if (button) {
            button.setAttribute('aria-expanded', 'false');
        }
    }

    function toggleLink(target) {
        const isActive = target.classList.contains('desktopMenu__itemWithChild--active');
        const childMenu = target.querySelector('.childMenu');

        if (isActive) {
            target.classList.remove('desktopMenu__itemWithChild--active');
            if (childMenu) {
                childMenu.setAttribute('hidden', '');
                childMenu.setAttribute('inert', '');
                childMenu.setAttribute('aria-hidden', 'true');
            }
        } else {
            target.classList.add('desktopMenu__itemWithChild--active');
            if (childMenu) {
                childMenu.removeAttribute('hidden');
                childMenu.removeAttribute('inert');
                childMenu.setAttribute('aria-hidden', 'false');
            }
        }

        // Toggle aria-expanded on the button child
        const button = target.querySelector('.desktopMenu__itemWithChildTitle');
        if (button) {
            button.setAttribute('aria-expanded', !isActive);
        }
    }

    linkWithChild.forEach(element => {
        element.addEventListener('click', (event) => {
            toggleLink(event.currentTarget);
        });

        // Close submenu on Escape and return focus to the trigger button
        element.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                const isActive = element.classList.contains('desktopMenu__itemWithChild--active');
                if (isActive) {
                    closeLink(element);
                    const button = element.querySelector('.desktopMenu__itemWithChildTitle');
                    if (button) button.focus();
                }
            }
        });
    });

    // Mobile menu: sync aria-expanded on <summary> with the native <details> open state
    document.querySelectorAll('[data-mobile-collapsible]').forEach(function(details) {
        var summary = details.querySelector('summary[aria-expanded]');
        if (!summary) return;

        details.addEventListener('toggle', function() {
            summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
    });
})